export default "__VITE_ASSET__CEke9fdO__"